module.exports = __webpack_public_path__ + "static/media/mobirise-icons.efe575ff.ttf";